
import VersionForm from "../components/VersionForm";
import { ParameterContext } from '../../contexts/ParameterContext';
import { useContext } from "react"
export function AdminShowVerSystem() {
    document.title = `Версия на приложението Прием I клас`;

    const { version } = useContext(ParameterContext)

    return (
        <main id="main" className="main">

            <div className="pagetitle">
                <h1 className="use-font">Версии на приложението</h1>
                <nav>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><a href="/schadm">Начало</a></li>
                        <li className="breadcrumb-item active">Преглед промени по версии</li>
                    </ol>
                </nav>
            </div>

            <section className="section dashboard">

                <div className="row">

                    <div className="col-lg-12">
                        <div className="row">
                            <VersionForm />
                        </div>
                    </div>

                </div>

            </section>

        </main>
    )
}

export default AdminShowVerSystem;